<script>
// import Input from "@/components/c-input";
// import Area from "@/components/c-input-area";
//import { stringify } from "querystring";
import i18n from "../i18n";

/* eslint-disable no-console */
/**
 * Item List component
 */
export default {
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {
    
  },
  methods: {
    show: function() {
      this.$refs[this.id].show();
    },
    hide: function() {
      this.$refs[this.id].hide();
    },
    getTitle: function() {
      if(this.full_title == ''){
        return `${i18n.t('property.text')}: ${this.title}`;
      }else{
        return this.full_title;
      }
      
    },
  },
  props: {
    id: {
      type: String,
    },
    item: {
      type: Object,
    },
    title: {
      type: String,
    },
    full_title: {
      type: String,
      default: '',
    },

    filters: null,
  },
};
</script>
<template>
  <div>
      <b-modal
        :id="id"
        :ref="id"
        centered
        size="xl"
        :title='getTitle()'
        title-class="font-22"
        hide-footer
        :hide-header-close="true"
      >
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <slot></slot>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
</template>